// export const primary = "#0d6efd";
export const primary = "#0a87ff";
export const font1 = "#6b7789";
export const gray1 = "rgba(79, 92, 111, 0.1)";
